import React, { useCallback } from "react";
import { Notification, Text } from "@flixbus/honeycomb-react";
import type { AppToastProps } from "./AppToast.types";

interface Props {
  toast: AppToastProps;
  onClose: (id: number) => void;
}

const AppToast: React.FC<Props> = ({ toast, onClose }) => {
  const closeLabel =
    toast.closeLabel ?? `Dismiss ${toast.appearance} notification`;
  const handleClose = useCallback(() => {
    onClose(toast.id);
  }, [onClose, toast.id]);

  return (
    <Notification
      toast={false}
      appearance={toast.appearance}
      closeProps={{
        "aria-label": closeLabel,
        onClick: handleClose,
      }}
    >
      <strong>{toast.message}</strong>
      {toast.description ? <Text>{toast.description}</Text> : null}
    </Notification>
  );
};

export default React.memo(AppToast);
